"use client";
import { usePathname } from "next/navigation";
import { useClientConfig } from "@/context/clientConfig";
import { getPagePathFromPathname } from "@/utils/url/getPagePathFromPathname";

export function useHideNavMenuOnPage(pagePaths: string[] = []) {
  const pathname = usePathname();
  const {
    tenantConfig: { singleSiteMode: isSingleSiteMode },
    siteConfig: { previewState, locale },
  } = useClientConfig();
  const pagePath = getPagePathFromPathname({
    pathname,
    isSingleSiteMode,
    isPreview: !!previewState,
    locale,
  });

  return pagePaths.includes(pagePath);
}
